'use client'

import dynamic from 'next/dynamic'
import { Container, Grid, Alert } from '@mui/material'

// Types
import type { CardItem } from '@/types/components/molecules/cards'
import type { LearnProps } from '@/types/components/pages/learn'

// Helpers
import { useTranslation } from '@/helpers/i18n/client'

// Components
const SliderOrganism = dynamic(() => import('@/components/organisms/slider'))
const SlideshowBoxCardMolecule = dynamic(() => import('@/components/molecules/cards/slideshow-box'))
const LearnCardMolecule = dynamic(() => import('@/components/molecules/cards/learn'))
const PaginationMolecule = dynamic(() => import('@/components/molecules/pagination'))

const LearnPage = (props: LearnProps) => {
	// Props
	const { lng, image, articles, limit, page, count, form } = props

	// Variables
	const { t } = useTranslation(lng)
	const totalPage = Math.ceil(count / limit)

	const cards: CardItem[] = articles.map(article => {
		const fv = article.fields_values ?? []

		return {
			title: article.title,
			image: fv && fv.length > 2 && fv[2].value ? fv[2].value : article.image,
			link: `/article/${article.alias}`,
			year: fv && fv.length > 0 && fv[0].value ? fv[0].value : undefined,
			subtitle: fv && fv.length > 1 && fv[1].value ? fv[1].value : undefined,
			description: fv && fv.length > 5 && fv[5].value ? fv[5].value : undefined
		}
	})

	// Box
	const fv = image?.fields_values ?? []
	let box: CardItem = {}

	if (Array.isArray(fv) && fv.length > 4) {
		box = {
			title: image?.title ?? '',
			image: fv[0].value,
			link: fv[1].value,
			year: fv[2].value,
			subtitle: fv[3].value,
			description: fv[4].value
		}
	}

	return (
		<Grid container spacing={3}>
			{image && (
				<SliderOrganism lng={lng} title={image.title} image={`/api/download${box.image}`} patternPosition="bottom" patternColor="#fff" form={form}>
			<Grid
				width={{ md: '30%' }}
				maxWidth={{ xs: '50%' }}
				position="absolute"
				top={{ xs: '50%', md: 60 }}
				left={{ xs: '50%', md: '90%' }}
				zIndex={1}
				sx={{ transform: { xs: 'translate(-50%, -50%)', md: 'translateX(-50%)' } }}
			>
				<SlideshowBoxCardMolecule
					lng={lng}
					{...box}
					sx={{
						textAlign: 'inherit',
						p: { xs: 2, md: 6 },
						pr: { xs: 2, md: 15 }
					}}
				/>
			</Grid>
		</SliderOrganism>
	)
}

<Grid size={12}>
	<Container>
		<Grid container spacing={2} mt={7}>
			{cards.map((card, index) => {
				return <LearnCardMolecule key={index} lng={lng} {...card} size="small" />
			})}
		</Grid>
	</Container>
</Grid>

{
	cards.length === 0 ? (
		<Grid size={12}>
			<Container>
				<Alert severity="warning">{t('common:description.notFoundItems')}</Alert>
			</Container>
		</Grid>
	) : null
}

<Grid size={12}>
	<Container>
		{totalPage > 1 && (
			<Grid container justifyContent="center" spacing={2}>
				<PaginationMolecule page={page} count={totalPage} />
			</Grid>
		)}
	</Container>
</Grid>
		</Grid >
	)
}

export default LearnPage
